import { isEmpty } from '../baseUtils';

const isSsr = (): boolean => typeof window === 'undefined';
export const setCookieTrackingIssueNo = async (value?: string) => {
  if (isEmpty(value)) {
    return;
  }

  const date = new Date();
  // 24시간 저장
  date.setHours(date.getHours() + 24);
  if (value) {
    if (isSsr()) {
      const { cookies } = await import('next/headers');
      const cookie = await cookies();
      cookie.set('trackingIssueNo', value, {
        path: '/',
        domain: '.wconcept.co.kr',
        expires: date,
      });
    } else {
      const { setCookie } = await import('cookies-next');
      setCookie('trackingIssueNo', value, {
        path: '/',
        domain: '.wconcept.co.kr',
        expires: date,
      });
    }
  }
};

// WckGenderValue Cookie에 세팅.

export const setCookieWckGenderValue = async (genderValue: string) => {
  if (isEmpty(genderValue)) {
    return;
  }
  // 10000 일 추가됨. (10000 * 24 * 60 * 60 * 1000)
  const date = new Date();
  date.setTime(date.getTime() + 864000000000);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckGenderValue', genderValue, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckGenderValue', genderValue, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// wckWMarketingValue(Women) Cookie에 세팅.

export const setCookieWckWMarketingValue = async (nowDate: string) => {
  if (isEmpty(nowDate)) {
    return;
  }
  // 10000 일 추가됨. (10000 * 24 * 60 * 60 * 1000)
  const date = new Date();
  date.setTime(date.getTime() + 864000000000);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckWMarketingValue', nowDate, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckWMarketingValue', nowDate, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// wckMMarketingValue(Men) Cookie에 세팅.

export const setCookieWckMMarketingValue = async (nowDate: string) => {
  if (isEmpty(nowDate)) {
    return;
  }
  // 10000 일 추가됨. (10000 * 24 * 60 * 60 * 1000)
  const date = new Date();
  date.setTime(date.getTime() + 864000000000);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckMMarketingValue', nowDate, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckMMarketingValue', nowDate, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// adfrom Cookie에 세팅.

export const setCookieAdfrom = async (adfrom: string) => {
  if (isEmpty(adfrom)) {
    return;
  }
  const date = new Date();
  // 20분 60 * 1000 * 20
  date.setTime(date.getTime() + 60 * 1000 * 20);
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('adfrom', adfrom, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('adfrom', adfrom, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

export const setCookieType = async (stype: string) => {
  if (isEmpty(stype)) {
    return;
  }
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('stype', stype, { path: '/', domain: '.wconcept.co.kr' });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('stype', stype, { path: '/', domain: '.wconcept.co.kr' });
  }
};

// 장바구니 카운트 조회.
